import React, { useEffect, useState } from "react";
import { Button, Container, Input } from "reactstrap";
import { Table, Row, Col, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { useNavigate } from "react-router-dom";
import DrugService from "Api/Services/DrugService";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import Paginations from "common/Paginations";
import Spinners from "components/Common/Spinner";
import UserActiveInactive from "components/Common/UserActiveInactive";
import PageTitle from "../../../components/Common/PageTitle";



const DrugList = () => {

    //meta title
    document.title = "Drug List | Infuse One";
    const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`;
    // Sample data (replace with API call)
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [drugs, setDrugs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteModal, setDeleteModal] = useState(false);
    // const [lastPage, setLastPage] = useState(1)
    const [totalPage, setTotalPage] = useState()
    const [totalData, setTotalData] = useState()
    const [deleteDrugId, setDeleteDrugId] = useState();
    const [isLoading, setLoading] = useState(false);
    const [drugToToggle, setDrugToToggle] = useState(null);
    const [drugActiveInactiveModal, setDrugActiveInactiveModal] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const navigate = useNavigate();


    useEffect(() => {
        LoadGruglist(1, globalFilter);
    }, [globalFilter]);


    const LoadGruglist = async (page, search) => {
        try {
            setLoading(true)
            const userData = {
                search: search ? search : ""
            }
            const response = await DrugService.GetDrugIndex(page, userData).json();
            if (response.status === true) {
                setDrugs(response.data);
                setCurrentPage(response.meta.current_page);
                setTotalPage(response.meta.last_page);
                setTotalData(response.meta.total);
                setLoading(false)
                // setTimeout(() => {
                //     setError('');
                //     setSuccess(response.message);
                // }, 100);
            } else {
                setLoading(false)
                setError(response.message);
                return;
            }
        } catch (error) {
            setError('Something went wrong');
            return;
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        LoadGruglist(page, globalFilter)
    }

    const handleDelete = async (drugId) => {
        setDeleteDrugId(drugId)
        setDeleteModal(true);
    };
    const handleDeleteUser = async () => {
        try {

            const response = await DrugService.deleteDrug(deleteDrugId);
            if (response.status) {
                setSuccess(response.message);
                setDrugs(drugs.filter((drug) => drug.id !== deleteDrugId));
                LoadGruglist(1, globalFilter);
                setDeleteModal(false);
                setLoading(true);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError('Something went wrong while deleting the drug');
        }

    };

    const handleUpdate = async (drugId) => {
        navigate(`/drug-edit/${drugId}`);
    };

    const handleDrugActiveInactive = (drug) => {
        setDrugToToggle(drug);
        setDrugActiveInactiveModal(true);
    };

    const handleActiveInactiveDrug = async () => {
        if (!drugToToggle) return;
        setLoading(true);
        try {
            const response = await DrugService.ChangeDrugStatus(drugToToggle.id);
            if (response.status) {
                setDrugs(drugs.map(drug =>
                    drug.id === drugToToggle.id ? { ...drug, status: !drugToToggle.status } : drug
                ));
                setSuccess(response.message);
                setDrugActiveInactiveModal(false);
                LoadGruglist(currentPage, globalFilter);
                setLoading(false);
            } else {
                setError(response.message);
            }
        } catch (error) {
            console.error(error);
            setError('Something went wrong while updating the drug status.');
        } finally {
            setDrugActiveInactiveModal(false);
            setDrugToToggle(null);
        };
    }

    // const SearchDrugname = async () => {
    //     try {
    //         const userData = {
    //             search: globalFilter ? globalFilter : '',
    //         }
    //         const response = await DrugService.searchDrug(userData).json();
    //         if (response.status) {
    //             setDrugs(response.data);
    //             setCurrentPage(response.meta.current_page);
    //             setTotalPage(response.meta.last_page);
    //             setTotalData(response.meta.total);
    //         } else {
    //             setError(response.message);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         setError('Something went wrong.');
    //     }
    // }


    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteUser}
                onCloseClick={() => setDeleteModal(false)}
            />

            <UserActiveInactive
                show={drugActiveInactiveModal}
                onChangeClick={() => handleActiveInactiveDrug()}
                onCloseClick={() => setDrugActiveInactiveModal(false)}
                isActive={drugToToggle ? drugToToggle?.status : false}
                modelType="drug"
            />

            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <PageTitle title="Drug List" />
                        <Row>
                            <Col lg={12}>
                                <Card className={isLoading ? "commonboxform pb-5" : "commonboxform"}>
                                    <CardBody>
                                        <div className='d-flex justify-content-between align-items-center mt-4 mb-3'>
                                            <div className="app-search p-0 d-flex gap-3">
                                                <div className="position-relative">
                                                    <Input type="text" name="search" className="form-control search-box px-3" value={globalFilter} placeholder="Search..." onChange={(e) => setGlobalFilter(e.target.value)} />
                                                </div>
                                                <div className="col-sm-auto">
                                                    <label className="visually-hidden" htmlFor="autoSizingSelect">Preference</label>
                                                    <select className="form-select" name="status" disabled>
                                                        <option value="">Filter Status...</option>
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <Link to="/drug-add" className='btn btn-secondary btn-rounded'><i className="mdi mdi-plus"></i>Add New Drug</Link>
                                        </div>

                                        <div className="table-responsive">
                                            <Table className="table mb-0">
                                                <thead>
                                                    <tr className="text-center">
                                                        <th>No</th>
                                                        <th>Name</th>
                                                        <th>Image</th>
                                                        <th>Iframe Form Url</th>
                                                        <th>Active</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="relativecls">
                                                    {isLoading ? <Spinners setLoading={setLoading} /> :
                                                        <>
                                                            {
                                                                drugs.map((drug, index) => (
                                                                    <tr key={drug.id} className="text-center">
                                                                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                                                                        <td>{drug.name}</td>
                                                                        <td>
                                                                            <img
                                                                                src={`${imageUrl}/${drug.image}`}
                                                                                alt={drug.name}
                                                                                className="img-fluid"
                                                                                style={{ width: '100px', height: '40px', objectFit: 'cover' }}
                                                                            />
                                                                        </td>
                                                                        <td>{drug.form_iframe}</td>
                                                                        <td>
                                                                            <a className="px-4 text-center" onClick={() => handleDrugActiveInactive(drug)}>
                                                                                {drug.status && drug.status == 1 ?
                                                                                    <span className="bg-success badge bg-secondary w-50 fs-6" >Active </span>
                                                                                    : <span className="bg-danger badge bg-secondary w-50 fs-6" >Inactive</span>
                                                                                }
                                                                            </a>
                                                                        </td>

                                                                        <td>
                                                                            <div className="d-flex gap-3 justify-content-center">
                                                                                <a className="text-success" onClick={() => handleUpdate(drug.id)}>
                                                                                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" title="Edit"></i>
                                                                                </a>
                                                                                <a className="text-danger" onClick={() => handleDelete(drug.id)} >
                                                                                    <i className="mdi mdi-delete font-size-18" id="deletetooltip" title="Delete"></i>
                                                                                </a>
                                                                            </div>

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </>
                                                    }
                                                </tbody>
                                            </Table>
                                            <h5 className="text-center mt-4">
                                                {drugs.length == 0 && !isLoading ? 'Data Not Found!' : ''}
                                            </h5>
                                            {drugs.length != 0 && !isLoading ?
                                                <Paginations
                                                    currentPage={currentPage}
                                                    totalPages={totalPage}
                                                    onPageChange={handlePageChange}
                                                />
                                                : ''}
                                        </div>

                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default DrugList;